import { useMemo } from 'react'
import { View, Text, Pressable, StyleSheet } from 'react-native'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../lib/AuthContext'
import { useThemeColors } from '../lib/useThemeColors'
import { fonts } from '../lib/theme'
import { COMPETITIONS } from '../lib/competitions'

// Uomini / Donne: due "app" separate dentro la stessa app (come le competizioni di VB). Cambia le leghe, le gare e tutto cio' che ne dipende.
export default function CompetitionSwitcher() {
  const { competitionId, switchCompetition } = useAuth()
  const tc = useThemeColors()
  const { t } = useTranslation()
  const styles = useMemo(() => makeStyles(tc), [tc])
  return (
    <View style={styles.cluster} accessibilityRole="tablist" accessibilityLabel={t('competition.aria')}>
      {COMPETITIONS.map(c => {
        const active = c.id === competitionId
        return (
          <Pressable
            key={c.id}
            onPress={() => switchCompetition(c.id)}
            hitSlop={{ top: 8, bottom: 8, left: 4, right: 4 }}
            accessibilityRole="tab"
            accessibilityLabel={t(c.labelKey)}
            accessibilityState={{ selected: active }}
            style={({ pressed }) => [styles.chip, active && { backgroundColor: tc.rosa, borderColor: tc.rosa }, pressed && { opacity: 0.8 }]}
          >
            <Text style={[styles.chipText, active && { color: tc.brandText }]} numberOfLines={1}>{t(c.labelKey).toUpperCase()}</Text>
          </Pressable>
        )
      })}
    </View>
  )
}

const makeStyles = (tc) => StyleSheet.create({
  cluster: { flexDirection: 'row', gap: 6, flexShrink: 0 },
  // stessa altezza (32px) e stile dei chip di VB; larghi quanto serve al nome (UOMINI / DONNE)
  chip: { height: 32, paddingHorizontal: 12, borderRadius: 16, borderWidth: 1.5, borderColor: tc.border, alignItems: 'center', justifyContent: 'center', flexShrink: 1 },
  chipText: { fontSize: 10, fontFamily: fonts.condensedBold, color: tc.textMuted, letterSpacing: 0.4 },
})
